import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { GroupedOpenQuestionAnswer, OpenQuestionAnswer } from '@core/candidate-types';
import { CollapseState } from '@core/common-legacy';

import type { DecoratedGroupedOpenQuestionAnswers } from '../candidate-questions.interfaces';
import type { CandidateQuestionsModuleTranslations } from '../translations';
import { CandidateQuestionsTranslations } from '../translations';
import { QuestionsMode } from '../types';
import { CandidateQuestionsItemComponent } from './candidate-questions-item/candidate-questions-item.component';

@Component({
  selector: 'rt-candidate-questions-result',
  templateUrl: './candidate-questions-result.component.html',
  styleUrls: ['./candidate-questions-result.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CandidateQuestionsItemComponent],
})
export class CandidateQuestionsResultComponent {
  public readonly translations = inject<CandidateQuestionsModuleTranslations>(
    CandidateQuestionsTranslations,
  );

  public readonly QuestionsMode: typeof QuestionsMode = QuestionsMode;

  public readonly visibilityTplRef = input<TemplateRef<any>>(undefined!);
  public readonly data = input<GroupedOpenQuestionAnswer, GroupedOpenQuestionAnswer>(undefined!, {
    transform: (
      value: GroupedOpenQuestionAnswer,
    ): GroupedOpenQuestionAnswer & {
      decoratedStatus: string;
    } => ({
      ...value,
      decoratedStatus: value.offer?.status ? value.offer.status : 'archived',
    }),
  });
  public readonly canManageCandidates = input<boolean>(false);
  public readonly hasBooleanFlagAnswers = input<boolean>(false);
  public readonly mode = input<QuestionsMode>(undefined!);

  public CollapseState: typeof CollapseState = CollapseState;

  public getGroupTitle(group: DecoratedGroupedOpenQuestionAnswers): string {
    const offerTitle = group.question.offer && group.question.offer.title;
    return offerTitle || '';
  }

  public hasTitleGroup(group: DecoratedGroupedOpenQuestionAnswers): boolean {
    return !!this.getGroupTitle(group);
  }

  public answersTrackBy(index: number, answer: OpenQuestionAnswer): number {
    return answer.id;
  }
}
